export var BatchMutationStatus = /* @__PURE__ */ ((BatchMutationStatus2) => {
  BatchMutationStatus2["Failure"] = "FAILURE";
  BatchMutationStatus2["MixedResults"] = "MIXED_RESULTS";
  BatchMutationStatus2["Success"] = "SUCCESS";
  return BatchMutationStatus2;
})(BatchMutationStatus || {});
export var CartItemErrorType = /* @__PURE__ */ ((CartItemErrorType2) => {
  CartItemErrorType2["ItemIncrements"] = "ITEM_INCREMENTS";
  CartItemErrorType2["ItemQty"] = "ITEM_QTY";
  CartItemErrorType2["Undefined"] = "UNDEFINED";
  return CartItemErrorType2;
})(CartItemErrorType || {});
export var CartUserInputErrorType = /* @__PURE__ */ ((CartUserInputErrorType2) => {
  CartUserInputErrorType2["InsufficientStock"] = "INSUFFICIENT_STOCK";
  CartUserInputErrorType2["NotSalable"] = "NOT_SALABLE";
  CartUserInputErrorType2["ProductNotFound"] = "PRODUCT_NOT_FOUND";
  CartUserInputErrorType2["Undefined"] = "UNDEFINED";
  return CartUserInputErrorType2;
})(CartUserInputErrorType || {});
export var CheckoutAgreementMode = /* @__PURE__ */ ((CheckoutAgreementMode2) => {
  CheckoutAgreementMode2["Auto"] = "AUTO";
  CheckoutAgreementMode2["Manual"] = "MANUAL";
  return CheckoutAgreementMode2;
})(CheckoutAgreementMode || {});
export var CheckoutUserInputErrorCodes = /* @__PURE__ */ ((CheckoutUserInputErrorCodes2) => {
  CheckoutUserInputErrorCodes2["InsufficientStock"] = "INSUFFICIENT_STOCK";
  CheckoutUserInputErrorCodes2["NotSalable"] = "NOT_SALABLE";
  CheckoutUserInputErrorCodes2["ProductNotFound"] = "PRODUCT_NOT_FOUND";
  CheckoutUserInputErrorCodes2["ReorderNotAvailable"] = "REORDER_NOT_AVAILABLE";
  CheckoutUserInputErrorCodes2["Undefined"] = "UNDEFINED";
  return CheckoutUserInputErrorCodes2;
})(CheckoutUserInputErrorCodes || {});
export var ConditionOperator = /* @__PURE__ */ ((ConditionOperator2) => {
  ConditionOperator2["Eq"] = "EQ";
  ConditionOperator2["Gt"] = "GT";
  ConditionOperator2["Gteq"] = "GTEQ";
  ConditionOperator2["Lt"] = "LT";
  ConditionOperator2["Lteq"] = "LTEQ";
  return ConditionOperator2;
})(ConditionOperator || {});
export var CountryCodeEnum = /* @__PURE__ */ ((CountryCodeEnum2) => {
  CountryCodeEnum2["Ad"] = "AD";
  CountryCodeEnum2["Ae"] = "AE";
  CountryCodeEnum2["Af"] = "AF";
  CountryCodeEnum2["Ag"] = "AG";
  CountryCodeEnum2["Ai"] = "AI";
  CountryCodeEnum2["Al"] = "AL";
  CountryCodeEnum2["Am"] = "AM";
  CountryCodeEnum2["An"] = "AN";
  CountryCodeEnum2["Ao"] = "AO";
  CountryCodeEnum2["Aq"] = "AQ";
  CountryCodeEnum2["Ar"] = "AR";
  CountryCodeEnum2["As"] = "AS";
  CountryCodeEnum2["At"] = "AT";
  CountryCodeEnum2["Au"] = "AU";
  CountryCodeEnum2["Aw"] = "AW";
  CountryCodeEnum2["Ax"] = "AX";
  CountryCodeEnum2["Az"] = "AZ";
  CountryCodeEnum2["Ba"] = "BA";
  CountryCodeEnum2["Bb"] = "BB";
  CountryCodeEnum2["Bd"] = "BD";
  CountryCodeEnum2["Be"] = "BE";
  CountryCodeEnum2["Bf"] = "BF";
  CountryCodeEnum2["Bg"] = "BG";
  CountryCodeEnum2["Bh"] = "BH";
  CountryCodeEnum2["Bi"] = "BI";
  CountryCodeEnum2["Bj"] = "BJ";
  CountryCodeEnum2["Bl"] = "BL";
  CountryCodeEnum2["Bm"] = "BM";
  CountryCodeEnum2["Bn"] = "BN";
  CountryCodeEnum2["Bo"] = "BO";
  CountryCodeEnum2["Br"] = "BR";
  CountryCodeEnum2["Bs"] = "BS";
  CountryCodeEnum2["Bt"] = "BT";
  CountryCodeEnum2["Bv"] = "BV";
  CountryCodeEnum2["Bw"] = "BW";
  CountryCodeEnum2["By"] = "BY";
  CountryCodeEnum2["Bz"] = "BZ";
  CountryCodeEnum2["Ca"] = "CA";
  CountryCodeEnum2["Cc"] = "CC";
  CountryCodeEnum2["Cd"] = "CD";
  CountryCodeEnum2["Cf"] = "CF";
  CountryCodeEnum2["Cg"] = "CG";
  CountryCodeEnum2["Ch"] = "CH";
  CountryCodeEnum2["Ci"] = "CI";
  CountryCodeEnum2["Ck"] = "CK";
  CountryCodeEnum2["Cl"] = "CL";
  CountryCodeEnum2["Cm"] = "CM";
  CountryCodeEnum2["Cn"] = "CN";
  CountryCodeEnum2["Co"] = "CO";
  CountryCodeEnum2["Cr"] = "CR";
  CountryCodeEnum2["Cu"] = "CU";
  CountryCodeEnum2["Cv"] = "CV";
  CountryCodeEnum2["Cx"] = "CX";
  CountryCodeEnum2["Cy"] = "CY";
  CountryCodeEnum2["Cz"] = "CZ";
  CountryCodeEnum2["De"] = "DE";
  CountryCodeEnum2["Dj"] = "DJ";
  CountryCodeEnum2["Dk"] = "DK";
  CountryCodeEnum2["Dm"] = "DM";
  CountryCodeEnum2["Do"] = "DO";
  CountryCodeEnum2["Dz"] = "DZ";
  CountryCodeEnum2["Ec"] = "EC";
  CountryCodeEnum2["Ee"] = "EE";
  CountryCodeEnum2["Eg"] = "EG";
  CountryCodeEnum2["Eh"] = "EH";
  CountryCodeEnum2["Er"] = "ER";
  CountryCodeEnum2["Es"] = "ES";
  CountryCodeEnum2["Et"] = "ET";
  CountryCodeEnum2["Fi"] = "FI";
  CountryCodeEnum2["Fj"] = "FJ";
  CountryCodeEnum2["Fk"] = "FK";
  CountryCodeEnum2["Fm"] = "FM";
  CountryCodeEnum2["Fo"] = "FO";
  CountryCodeEnum2["Fr"] = "FR";
  CountryCodeEnum2["Ga"] = "GA";
  CountryCodeEnum2["Gb"] = "GB";
  CountryCodeEnum2["Gd"] = "GD";
  CountryCodeEnum2["Ge"] = "GE";
  CountryCodeEnum2["Gf"] = "GF";
  CountryCodeEnum2["Gg"] = "GG";
  CountryCodeEnum2["Gh"] = "GH";
  CountryCodeEnum2["Gi"] = "GI";
  CountryCodeEnum2["Gl"] = "GL";
  CountryCodeEnum2["Gm"] = "GM";
  CountryCodeEnum2["Gn"] = "GN";
  CountryCodeEnum2["Gp"] = "GP";
  CountryCodeEnum2["Gq"] = "GQ";
  CountryCodeEnum2["Gr"] = "GR";
  CountryCodeEnum2["Gs"] = "GS";
  CountryCodeEnum2["Gt"] = "GT";
  CountryCodeEnum2["Gu"] = "GU";
  CountryCodeEnum2["Gw"] = "GW";
  CountryCodeEnum2["Gy"] = "GY";
  CountryCodeEnum2["Hk"] = "HK";
  CountryCodeEnum2["Hm"] = "HM";
  CountryCodeEnum2["Hn"] = "HN";
  CountryCodeEnum2["Hr"] = "HR";
  CountryCodeEnum2["Ht"] = "HT";
  CountryCodeEnum2["Hu"] = "HU";
  CountryCodeEnum2["Id"] = "ID";
  CountryCodeEnum2["Ie"] = "IE";
  CountryCodeEnum2["Il"] = "IL";
  CountryCodeEnum2["Im"] = "IM";
  CountryCodeEnum2["In"] = "IN";
  CountryCodeEnum2["Io"] = "IO";
  CountryCodeEnum2["Iq"] = "IQ";
  CountryCodeEnum2["Ir"] = "IR";
  CountryCodeEnum2["Is"] = "IS";
  CountryCodeEnum2["It"] = "IT";
  CountryCodeEnum2["Je"] = "JE";
  CountryCodeEnum2["Jm"] = "JM";
  CountryCodeEnum2["Jo"] = "JO";
  CountryCodeEnum2["Jp"] = "JP";
  CountryCodeEnum2["Ke"] = "KE";
  CountryCodeEnum2["Kg"] = "KG";
  CountryCodeEnum2["Kh"] = "KH";
  CountryCodeEnum2["Ki"] = "KI";
  CountryCodeEnum2["Km"] = "KM";
  CountryCodeEnum2["Kn"] = "KN";
  CountryCodeEnum2["Kp"] = "KP";
  CountryCodeEnum2["Kr"] = "KR";
  CountryCodeEnum2["Kw"] = "KW";
  CountryCodeEnum2["Ky"] = "KY";
  CountryCodeEnum2["Kz"] = "KZ";
  CountryCodeEnum2["La"] = "LA";
  CountryCodeEnum2["Lb"] = "LB";
  CountryCodeEnum2["Lc"] = "LC";
  CountryCodeEnum2["Li"] = "LI";
  CountryCodeEnum2["Lk"] = "LK";
  CountryCodeEnum2["Lr"] = "LR";
  CountryCodeEnum2["Ls"] = "LS";
  CountryCodeEnum2["Lt"] = "LT";
  CountryCodeEnum2["Lu"] = "LU";
  CountryCodeEnum2["Lv"] = "LV";
  CountryCodeEnum2["Ly"] = "LY";
  CountryCodeEnum2["Ma"] = "MA";
  CountryCodeEnum2["Mc"] = "MC";
  CountryCodeEnum2["Md"] = "MD";
  CountryCodeEnum2["Me"] = "ME";
  CountryCodeEnum2["Mf"] = "MF";
  CountryCodeEnum2["Mg"] = "MG";
  CountryCodeEnum2["Mh"] = "MH";
  CountryCodeEnum2["Mk"] = "MK";
  CountryCodeEnum2["Ml"] = "ML";
  CountryCodeEnum2["Mm"] = "MM";
  CountryCodeEnum2["Mn"] = "MN";
  CountryCodeEnum2["Mo"] = "MO";
  CountryCodeEnum2["Mp"] = "MP";
  CountryCodeEnum2["Mq"] = "MQ";
  CountryCodeEnum2["Mr"] = "MR";
  CountryCodeEnum2["Ms"] = "MS";
  CountryCodeEnum2["Mt"] = "MT";
  CountryCodeEnum2["Mu"] = "MU";
  CountryCodeEnum2["Mv"] = "MV";
  CountryCodeEnum2["Mw"] = "MW";
  CountryCodeEnum2["Mx"] = "MX";
  CountryCodeEnum2["My"] = "MY";
  CountryCodeEnum2["Mz"] = "MZ";
  CountryCodeEnum2["Na"] = "NA";
  CountryCodeEnum2["Nc"] = "NC";
  CountryCodeEnum2["Ne"] = "NE";
  CountryCodeEnum2["Nf"] = "NF";
  CountryCodeEnum2["Ng"] = "NG";
  CountryCodeEnum2["Ni"] = "NI";
  CountryCodeEnum2["Nl"] = "NL";
  CountryCodeEnum2["No"] = "NO";
  CountryCodeEnum2["Np"] = "NP";
  CountryCodeEnum2["Nr"] = "NR";
  CountryCodeEnum2["Nu"] = "NU";
  CountryCodeEnum2["Nz"] = "NZ";
  CountryCodeEnum2["Om"] = "OM";
  CountryCodeEnum2["Pa"] = "PA";
  CountryCodeEnum2["Pe"] = "PE";
  CountryCodeEnum2["Pf"] = "PF";
  CountryCodeEnum2["Pg"] = "PG";
  CountryCodeEnum2["Ph"] = "PH";
  CountryCodeEnum2["Pk"] = "PK";
  CountryCodeEnum2["Pl"] = "PL";
  CountryCodeEnum2["Pm"] = "PM";
  CountryCodeEnum2["Pn"] = "PN";
  CountryCodeEnum2["Ps"] = "PS";
  CountryCodeEnum2["Pt"] = "PT";
  CountryCodeEnum2["Pw"] = "PW";
  CountryCodeEnum2["Py"] = "PY";
  CountryCodeEnum2["Qa"] = "QA";
  CountryCodeEnum2["Re"] = "RE";
  CountryCodeEnum2["Ro"] = "RO";
  CountryCodeEnum2["Rs"] = "RS";
  CountryCodeEnum2["Ru"] = "RU";
  CountryCodeEnum2["Rw"] = "RW";
  CountryCodeEnum2["Sa"] = "SA";
  CountryCodeEnum2["Sb"] = "SB";
  CountryCodeEnum2["Sc"] = "SC";
  CountryCodeEnum2["Sd"] = "SD";
  CountryCodeEnum2["Se"] = "SE";
  CountryCodeEnum2["Sg"] = "SG";
  CountryCodeEnum2["Sh"] = "SH";
  CountryCodeEnum2["Si"] = "SI";
  CountryCodeEnum2["Sj"] = "SJ";
  CountryCodeEnum2["Sk"] = "SK";
  CountryCodeEnum2["Sl"] = "SL";
  CountryCodeEnum2["Sm"] = "SM";
  CountryCodeEnum2["Sn"] = "SN";
  CountryCodeEnum2["So"] = "SO";
  CountryCodeEnum2["Sr"] = "SR";
  CountryCodeEnum2["St"] = "ST";
  CountryCodeEnum2["Sv"] = "SV";
  CountryCodeEnum2["Sy"] = "SY";
  CountryCodeEnum2["Sz"] = "SZ";
  CountryCodeEnum2["Tc"] = "TC";
  CountryCodeEnum2["Td"] = "TD";
  CountryCodeEnum2["Tf"] = "TF";
  CountryCodeEnum2["Tg"] = "TG";
  CountryCodeEnum2["Th"] = "TH";
  CountryCodeEnum2["Tj"] = "TJ";
  CountryCodeEnum2["Tk"] = "TK";
  CountryCodeEnum2["Tl"] = "TL";
  CountryCodeEnum2["Tm"] = "TM";
  CountryCodeEnum2["Tn"] = "TN";
  CountryCodeEnum2["To"] = "TO";
  CountryCodeEnum2["Tr"] = "TR";
  CountryCodeEnum2["Tt"] = "TT";
  CountryCodeEnum2["Tv"] = "TV";
  CountryCodeEnum2["Tw"] = "TW";
  CountryCodeEnum2["Tz"] = "TZ";
  CountryCodeEnum2["Ua"] = "UA";
  CountryCodeEnum2["Ug"] = "UG";
  CountryCodeEnum2["Um"] = "UM";
  CountryCodeEnum2["Us"] = "US";
  CountryCodeEnum2["Uy"] = "UY";
  CountryCodeEnum2["Uz"] = "UZ";
  CountryCodeEnum2["Va"] = "VA";
  CountryCodeEnum2["Vc"] = "VC";
  CountryCodeEnum2["Ve"] = "VE";
  CountryCodeEnum2["Vg"] = "VG";
  CountryCodeEnum2["Vi"] = "VI";
  CountryCodeEnum2["Vn"] = "VN";
  CountryCodeEnum2["Vu"] = "VU";
  CountryCodeEnum2["Wf"] = "WF";
  CountryCodeEnum2["Ws"] = "WS";
  CountryCodeEnum2["Ye"] = "YE";
  CountryCodeEnum2["Yt"] = "YT";
  CountryCodeEnum2["Za"] = "ZA";
  CountryCodeEnum2["Zm"] = "ZM";
  CountryCodeEnum2["Zw"] = "ZW";
  return CountryCodeEnum2;
})(CountryCodeEnum || {});
export var CurrencyEnum = /* @__PURE__ */ ((CurrencyEnum2) => {
  CurrencyEnum2["Aed"] = "AED";
  CurrencyEnum2["Afn"] = "AFN";
  CurrencyEnum2["All"] = "ALL";
  CurrencyEnum2["Amd"] = "AMD";
  CurrencyEnum2["Ang"] = "ANG";
  CurrencyEnum2["Aoa"] = "AOA";
  CurrencyEnum2["Ars"] = "ARS";
  CurrencyEnum2["Aud"] = "AUD";
  CurrencyEnum2["Awg"] = "AWG";
  CurrencyEnum2["Azm"] = "AZM";
  CurrencyEnum2["Azn"] = "AZN";
  CurrencyEnum2["Bam"] = "BAM";
  CurrencyEnum2["Bbd"] = "BBD";
  CurrencyEnum2["Bdt"] = "BDT";
  CurrencyEnum2["Bgn"] = "BGN";
  CurrencyEnum2["Bhd"] = "BHD";
  CurrencyEnum2["Bif"] = "BIF";
  CurrencyEnum2["Bmd"] = "BMD";
  CurrencyEnum2["Bnd"] = "BND";
  CurrencyEnum2["Bob"] = "BOB";
  CurrencyEnum2["Brl"] = "BRL";
  CurrencyEnum2["Bsd"] = "BSD";
  CurrencyEnum2["Btn"] = "BTN";
  CurrencyEnum2["Buk"] = "BUK";
  CurrencyEnum2["Bwp"] = "BWP";
  CurrencyEnum2["Byn"] = "BYN";
  CurrencyEnum2["Bzd"] = "BZD";
  CurrencyEnum2["Cad"] = "CAD";
  CurrencyEnum2["Cdf"] = "CDF";
  CurrencyEnum2["Che"] = "CHE";
  CurrencyEnum2["Chf"] = "CHF";
  CurrencyEnum2["Chw"] = "CHW";
  CurrencyEnum2["Clp"] = "CLP";
  CurrencyEnum2["Cny"] = "CNY";
  CurrencyEnum2["Cop"] = "COP";
  CurrencyEnum2["Crc"] = "CRC";
  CurrencyEnum2["Cup"] = "CUP";
  CurrencyEnum2["Cve"] = "CVE";
  CurrencyEnum2["Czk"] = "CZK";
  CurrencyEnum2["Djf"] = "DJF";
  CurrencyEnum2["Dkk"] = "DKK";
  CurrencyEnum2["Dop"] = "DOP";
  CurrencyEnum2["Dzd"] = "DZD";
  CurrencyEnum2["Eek"] = "EEK";
  CurrencyEnum2["Egp"] = "EGP";
  CurrencyEnum2["Ern"] = "ERN";
  CurrencyEnum2["Etb"] = "ETB";
  CurrencyEnum2["Eur"] = "EUR";
  CurrencyEnum2["Fjd"] = "FJD";
  CurrencyEnum2["Fkp"] = "FKP";
  CurrencyEnum2["Gbp"] = "GBP";
  CurrencyEnum2["Gek"] = "GEK";
  CurrencyEnum2["Gel"] = "GEL";
  CurrencyEnum2["Ghs"] = "GHS";
  CurrencyEnum2["Gip"] = "GIP";
  CurrencyEnum2["Gmd"] = "GMD";
  CurrencyEnum2["Gnf"] = "GNF";
  CurrencyEnum2["Gqe"] = "GQE";
  CurrencyEnum2["Gtq"] = "GTQ";
  CurrencyEnum2["Gyd"] = "GYD";
  CurrencyEnum2["Hkd"] = "HKD";
  CurrencyEnum2["Hnl"] = "HNL";
  CurrencyEnum2["Hrk"] = "HRK";
  CurrencyEnum2["Htg"] = "HTG";
  CurrencyEnum2["Huf"] = "HUF";
  CurrencyEnum2["Idr"] = "IDR";
  CurrencyEnum2["Ils"] = "ILS";
  CurrencyEnum2["Inr"] = "INR";
  CurrencyEnum2["Iqd"] = "IQD";
  CurrencyEnum2["Irr"] = "IRR";
  CurrencyEnum2["Isk"] = "ISK";
  CurrencyEnum2["Jmd"] = "JMD";
  CurrencyEnum2["Jod"] = "JOD";
  CurrencyEnum2["Jpy"] = "JPY";
  CurrencyEnum2["Kes"] = "KES";
  CurrencyEnum2["Kgs"] = "KGS";
  CurrencyEnum2["Khr"] = "KHR";
  CurrencyEnum2["Kmf"] = "KMF";
  CurrencyEnum2["Kpw"] = "KPW";
  CurrencyEnum2["Krw"] = "KRW";
  CurrencyEnum2["Kwd"] = "KWD";
  CurrencyEnum2["Kyd"] = "KYD";
  CurrencyEnum2["Kzt"] = "KZT";
  CurrencyEnum2["Lak"] = "LAK";
  CurrencyEnum2["Lbp"] = "LBP";
  CurrencyEnum2["Lkr"] = "LKR";
  CurrencyEnum2["Lrd"] = "LRD";
  CurrencyEnum2["Lsl"] = "LSL";
  CurrencyEnum2["Lsm"] = "LSM";
  CurrencyEnum2["Ltl"] = "LTL";
  CurrencyEnum2["Lvl"] = "LVL";
  CurrencyEnum2["Lyd"] = "LYD";
  CurrencyEnum2["Mad"] = "MAD";
  CurrencyEnum2["Mdl"] = "MDL";
  CurrencyEnum2["Mga"] = "MGA";
  CurrencyEnum2["Mkd"] = "MKD";
  CurrencyEnum2["Mmk"] = "MMK";
  CurrencyEnum2["Mnt"] = "MNT";
  CurrencyEnum2["Mop"] = "MOP";
  CurrencyEnum2["Mro"] = "MRO";
  CurrencyEnum2["Mur"] = "MUR";
  CurrencyEnum2["Mvr"] = "MVR";
  CurrencyEnum2["Mwk"] = "MWK";
  CurrencyEnum2["Mxn"] = "MXN";
  CurrencyEnum2["Myr"] = "MYR";
  CurrencyEnum2["Mzn"] = "MZN";
  CurrencyEnum2["Nad"] = "NAD";
  CurrencyEnum2["Ngn"] = "NGN";
  CurrencyEnum2["Nic"] = "NIC";
  CurrencyEnum2["Nok"] = "NOK";
  CurrencyEnum2["Npr"] = "NPR";
  CurrencyEnum2["Nzd"] = "NZD";
  CurrencyEnum2["Omr"] = "OMR";
  CurrencyEnum2["Pab"] = "PAB";
  CurrencyEnum2["Pen"] = "PEN";
  CurrencyEnum2["Pgk"] = "PGK";
  CurrencyEnum2["Php"] = "PHP";
  CurrencyEnum2["Pkr"] = "PKR";
  CurrencyEnum2["Pln"] = "PLN";
  CurrencyEnum2["Pyg"] = "PYG";
  CurrencyEnum2["Qar"] = "QAR";
  CurrencyEnum2["Rhd"] = "RHD";
  CurrencyEnum2["Rol"] = "ROL";
  CurrencyEnum2["Ron"] = "RON";
  CurrencyEnum2["Rsd"] = "RSD";
  CurrencyEnum2["Rub"] = "RUB";
  CurrencyEnum2["Rwf"] = "RWF";
  CurrencyEnum2["Sar"] = "SAR";
  CurrencyEnum2["Sbd"] = "SBD";
  CurrencyEnum2["Scr"] = "SCR";
  CurrencyEnum2["Sdg"] = "SDG";
  CurrencyEnum2["Sek"] = "SEK";
  CurrencyEnum2["Sgd"] = "SGD";
  CurrencyEnum2["Shp"] = "SHP";
  CurrencyEnum2["Skk"] = "SKK";
  CurrencyEnum2["Sll"] = "SLL";
  CurrencyEnum2["Sos"] = "SOS";
  CurrencyEnum2["Srd"] = "SRD";
  CurrencyEnum2["Std"] = "STD";
  CurrencyEnum2["Svc"] = "SVC";
  CurrencyEnum2["Syp"] = "SYP";
  CurrencyEnum2["Szl"] = "SZL";
  CurrencyEnum2["Thb"] = "THB";
  CurrencyEnum2["Tjs"] = "TJS";
  CurrencyEnum2["Tmm"] = "TMM";
  CurrencyEnum2["Tnd"] = "TND";
  CurrencyEnum2["Top"] = "TOP";
  CurrencyEnum2["Trl"] = "TRL";
  CurrencyEnum2["Try"] = "TRY";
  CurrencyEnum2["Ttd"] = "TTD";
  CurrencyEnum2["Twd"] = "TWD";
  CurrencyEnum2["Tzs"] = "TZS";
  CurrencyEnum2["Uah"] = "UAH";
  CurrencyEnum2["Ugx"] = "UGX";
  CurrencyEnum2["Usd"] = "USD";
  CurrencyEnum2["Uyu"] = "UYU";
  CurrencyEnum2["Uzs"] = "UZS";
  CurrencyEnum2["Veb"] = "VEB";
  CurrencyEnum2["Vef"] = "VEF";
  CurrencyEnum2["Vnd"] = "VND";
  CurrencyEnum2["Vuv"] = "VUV";
  CurrencyEnum2["Wst"] = "WST";
  CurrencyEnum2["Xcd"] = "XCD";
  CurrencyEnum2["Xof"] = "XOF";
  CurrencyEnum2["Xpf"] = "XPF";
  CurrencyEnum2["Yer"] = "YER";
  CurrencyEnum2["Ytl"] = "YTL";
  CurrencyEnum2["Zar"] = "ZAR";
  CurrencyEnum2["Zmk"] = "ZMK";
  CurrencyEnum2["Zwd"] = "ZWD";
  return CurrencyEnum2;
})(CurrencyEnum || {});
export var CustomerOrderSortableField = /* @__PURE__ */ ((CustomerOrderSortableField2) => {
  CustomerOrderSortableField2["CreatedAt"] = "CREATED_AT";
  CustomerOrderSortableField2["Number"] = "NUMBER";
  return CustomerOrderSortableField2;
})(CustomerOrderSortableField || {});
export var CustomizableDateTypeEnum = /* @__PURE__ */ ((CustomizableDateTypeEnum2) => {
  CustomizableDateTypeEnum2["Date"] = "DATE";
  CustomizableDateTypeEnum2["DateTime"] = "DATE_TIME";
  CustomizableDateTypeEnum2["Time"] = "TIME";
  return CustomizableDateTypeEnum2;
})(CustomizableDateTypeEnum || {});
export var DiscountAction = /* @__PURE__ */ ((DiscountAction2) => {
  DiscountAction2["BuyXGetYfree"] = "BUY_X_GET_YFREE";
  DiscountAction2["BuyXGetYprecent"] = "BUY_X_GET_YPRECENT";
  DiscountAction2["ByPercentage"] = "BY_PERCENTAGE";
  DiscountAction2["CappedPercentage"] = "CAPPED_PERCENTAGE";
  DiscountAction2["Fixed"] = "FIXED";
  return DiscountAction2;
})(DiscountAction || {});
export var DownloadableFileTypeEnum = /* @__PURE__ */ ((DownloadableFileTypeEnum2) => {
  DownloadableFileTypeEnum2["File"] = "FILE";
  DownloadableFileTypeEnum2["Url"] = "URL";
  return DownloadableFileTypeEnum2;
})(DownloadableFileTypeEnum || {});
export var FcmChannelEnum = /* @__PURE__ */ ((FcmChannelEnum2) => {
  FcmChannelEnum2["Android"] = "ANDROID";
  FcmChannelEnum2["Ios"] = "IOS";
  FcmChannelEnum2["Web"] = "WEB";
  return FcmChannelEnum2;
})(FcmChannelEnum || {});
export var FixedProductTaxDisplaySettings = /* @__PURE__ */ ((FixedProductTaxDisplaySettings2) => {
  FixedProductTaxDisplaySettings2["ExcludeFptAndIncludeWithDetails"] = "EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS";
  FixedProductTaxDisplaySettings2["ExcludeFptWithoutDetails"] = "EXCLUDE_FPT_WITHOUT_DETAILS";
  FixedProductTaxDisplaySettings2["FptDisabled"] = "FPT_DISABLED";
  FixedProductTaxDisplaySettings2["IncludeFptWithoutDetails"] = "INCLUDE_FPT_WITHOUT_DETAILS";
  FixedProductTaxDisplaySettings2["IncludeFptWithDetails"] = "INCLUDE_FPT_WITH_DETAILS";
  return FixedProductTaxDisplaySettings2;
})(FixedProductTaxDisplaySettings || {});
export var MageWorxGiftCardTypeEnum = /* @__PURE__ */ ((MageWorxGiftCardTypeEnum2) => {
  MageWorxGiftCardTypeEnum2["Email"] = "EMAIL";
  MageWorxGiftCardTypeEnum2["Offline"] = "OFFLINE";
  MageWorxGiftCardTypeEnum2["Print"] = "PRINT";
  return MageWorxGiftCardTypeEnum2;
})(MageWorxGiftCardTypeEnum || {});
export var PayflowLinkMode = /* @__PURE__ */ ((PayflowLinkMode2) => {
  PayflowLinkMode2["Live"] = "LIVE";
  PayflowLinkMode2["Test"] = "TEST";
  return PayflowLinkMode2;
})(PayflowLinkMode || {});
export var PaymentTokenTypeEnum = /* @__PURE__ */ ((PaymentTokenTypeEnum2) => {
  PaymentTokenTypeEnum2["Account"] = "account";
  PaymentTokenTypeEnum2["Card"] = "card";
  return PaymentTokenTypeEnum2;
})(PaymentTokenTypeEnum || {});
export var PriceAdjustmentCodesEnum = /* @__PURE__ */ ((PriceAdjustmentCodesEnum2) => {
  PriceAdjustmentCodesEnum2["Tax"] = "TAX";
  PriceAdjustmentCodesEnum2["Weee"] = "WEEE";
  PriceAdjustmentCodesEnum2["WeeeTax"] = "WEEE_TAX";
  return PriceAdjustmentCodesEnum2;
})(PriceAdjustmentCodesEnum || {});
export var PriceAdjustmentDescriptionEnum = /* @__PURE__ */ ((PriceAdjustmentDescriptionEnum2) => {
  PriceAdjustmentDescriptionEnum2["Excluded"] = "EXCLUDED";
  PriceAdjustmentDescriptionEnum2["Included"] = "INCLUDED";
  return PriceAdjustmentDescriptionEnum2;
})(PriceAdjustmentDescriptionEnum || {});
export var PriceTypeEnum = /* @__PURE__ */ ((PriceTypeEnum2) => {
  PriceTypeEnum2["Dynamic"] = "DYNAMIC";
  PriceTypeEnum2["Fixed"] = "FIXED";
  PriceTypeEnum2["Percent"] = "PERCENT";
  return PriceTypeEnum2;
})(PriceTypeEnum || {});
export var PriceViewEnum = /* @__PURE__ */ ((PriceViewEnum2) => {
  PriceViewEnum2["AsLowAs"] = "AS_LOW_AS";
  PriceViewEnum2["PriceRange"] = "PRICE_RANGE";
  return PriceViewEnum2;
})(PriceViewEnum || {});
export var ProductStockStatus = /* @__PURE__ */ ((ProductStockStatus2) => {
  ProductStockStatus2["InStock"] = "IN_STOCK";
  ProductStockStatus2["OutOfStock"] = "OUT_OF_STOCK";
  return ProductStockStatus2;
})(ProductStockStatus || {});
export var ScopeTypeEnum = /* @__PURE__ */ ((ScopeTypeEnum2) => {
  ScopeTypeEnum2["Global"] = "GLOBAL";
  ScopeTypeEnum2["Store"] = "STORE";
  ScopeTypeEnum2["Website"] = "WEBSITE";
  return ScopeTypeEnum2;
})(ScopeTypeEnum || {});
export var ShipBundleItemsEnum = /* @__PURE__ */ ((ShipBundleItemsEnum2) => {
  ShipBundleItemsEnum2["Separately"] = "SEPARATELY";
  ShipBundleItemsEnum2["Together"] = "TOGETHER";
  return ShipBundleItemsEnum2;
})(ShipBundleItemsEnum || {});
export var SocialProviderEnum = /* @__PURE__ */ ((SocialProviderEnum2) => {
  SocialProviderEnum2["Apple"] = "APPLE";
  SocialProviderEnum2["Facebook"] = "FACEBOOK";
  SocialProviderEnum2["Google"] = "GOOGLE";
  return SocialProviderEnum2;
})(SocialProviderEnum || {});
export var SortEnum = /* @__PURE__ */ ((SortEnum2) => {
  SortEnum2["Asc"] = "ASC";
  SortEnum2["Desc"] = "DESC";
  return SortEnum2;
})(SortEnum || {});
export var StoreTypeEnum = /* @__PURE__ */ ((StoreTypeEnum2) => {
  StoreTypeEnum2["ServiceCenter"] = "SERVICE_CENTER";
  StoreTypeEnum2["Store"] = "STORE";
  return StoreTypeEnum2;
})(StoreTypeEnum || {});
export var SubscriptionStatusesEnum = /* @__PURE__ */ ((SubscriptionStatusesEnum2) => {
  SubscriptionStatusesEnum2["NotActive"] = "NOT_ACTIVE";
  SubscriptionStatusesEnum2["Subscribed"] = "SUBSCRIBED";
  SubscriptionStatusesEnum2["Unconfirmed"] = "UNCONFIRMED";
  SubscriptionStatusesEnum2["Unsubscribed"] = "UNSUBSCRIBED";
  return SubscriptionStatusesEnum2;
})(SubscriptionStatusesEnum || {});
export var UrlRewriteEntityTypeEnum = /* @__PURE__ */ ((UrlRewriteEntityTypeEnum2) => {
  UrlRewriteEntityTypeEnum2["Category"] = "CATEGORY";
  UrlRewriteEntityTypeEnum2["CmsPage"] = "CMS_PAGE";
  UrlRewriteEntityTypeEnum2["Product"] = "PRODUCT";
  return UrlRewriteEntityTypeEnum2;
})(UrlRewriteEntityTypeEnum || {});
export var UseInLayeredNavigationOptions = /* @__PURE__ */ ((UseInLayeredNavigationOptions2) => {
  UseInLayeredNavigationOptions2["FilterableNoResult"] = "FILTERABLE_NO_RESULT";
  UseInLayeredNavigationOptions2["FilterableWithResults"] = "FILTERABLE_WITH_RESULTS";
  UseInLayeredNavigationOptions2["No"] = "NO";
  return UseInLayeredNavigationOptions2;
})(UseInLayeredNavigationOptions || {});
export var WishListUserInputErrorType = /* @__PURE__ */ ((WishListUserInputErrorType2) => {
  WishListUserInputErrorType2["ProductNotFound"] = "PRODUCT_NOT_FOUND";
  WishListUserInputErrorType2["Undefined"] = "UNDEFINED";
  return WishListUserInputErrorType2;
})(WishListUserInputErrorType || {});
export var WishlistCartUserInputErrorType = /* @__PURE__ */ ((WishlistCartUserInputErrorType2) => {
  WishlistCartUserInputErrorType2["InsufficientStock"] = "INSUFFICIENT_STOCK";
  WishlistCartUserInputErrorType2["NotSalable"] = "NOT_SALABLE";
  WishlistCartUserInputErrorType2["ProductNotFound"] = "PRODUCT_NOT_FOUND";
  WishlistCartUserInputErrorType2["Undefined"] = "UNDEFINED";
  return WishlistCartUserInputErrorType2;
})(WishlistCartUserInputErrorType || {});
export class TypedDocumentString extends String {
  constructor(value, __meta__) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }
  __apiType;
  toString() {
    return this.value;
  }
}
export const StoreLocationFragmentDoc = new TypedDocumentString(`
    fragment StoreLocation on PickupLocation {
  street
  email
  latitude
  longitude
  name
  phone
  city
  region
}
    `, { "fragmentName": "StoreLocation" });
export const GetAllStoresDocument = new TypedDocumentString(`
    query GetAllStores {
  storeLocators {
    items {
      address
      city {
        code
        id
        is_active
        name
      }
      code
      email
      id
      image_url
      is_active
      latitude
      longitude
      name
      phone_number
      region {
        available_cities(filter: {}) {
          code
          id
          is_active
          name
        }
        code
        id
        is_active
        name
      }
      type
      working_hours
    }
  }
}
    `);
export const SetShippingLocationOnCartDocument = new TypedDocumentString(`
    mutation SetShippingLocationOnCart($cartId: String!, $storeId: Int!) {
  response: setShippingLocationOnCart(
    input: {cart_id: $cartId, store_id: $storeId}
  ) {
    cart {
      id
    }
  }
}
    `);
